import { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import PostJob from './PostJob';
import styles from './ManageJob.module.css';
import ProfileSideBar from '../../components/UI/Common/ProfileSideBar/ProfileSideBar';
import EmployerPortalJobList from '../../components/UI/Common/EmployerPortalJobList/EmployerPortalJobList';
import EmployerPortalCandidates from '../../components/UI/Common/EmployerPortalCandidates/EmployerPortalCandidates';
import EmployerPortalApplication from '../../components/UI/Common/EmployerPortalApplications/EmployerPortalApplications';
import {
    ApplicationIcon,
    Briefcase,
    CandidateIcon
} from '../../assets/images/icons';

function ManageJob() {
    const { t } = useTranslation();
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState(0);
    const [activeSteps, setActiveSteps] = useState(1);
    const [postJobEnable, setPostJobEnable] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (location.pathname == '/employer-portal/jobs') { setActiveTab(0) }
        else if (location.pathname == '/employer-portal/candidates') { setActiveTab(1) }
        else if (location.pathname == '/employer-portal/applicants') { setActiveTab(2) }
        else if (location.pathname == '/employer-portal/create-job') {
            setActiveTab(0)
            setPostJobEnable(true)
        }
    }, [location.pathname])

    const tabs = [
        { name: 'jobs', icon: Briefcase },
        { name: 'candidates', icon: CandidateIcon },
        { name: 'applications', icon: ApplicationIcon },
    ];
    useEffect(() => {
        if (postJobEnable) { navigate('/employer-portal/create-job') }
    }, [postJobEnable])
    return (
        <>
            {id &&
                location.pathname !== "/employer-portal/" + id ?
                (
                    <>
                        <Helmet>
                            <title>FindCV - Edit Job</title>
                        </Helmet>
                        <div className={`${styles.container} ${styles.fcvRow} ${postJobEnable ? styles.borderDisabled : styles.borderEnabled}`}>
                            <span className={`${styles.spanStyle} ${postJobEnable ? styles.borderTopBottomEnabled : styles.borderTopBottomDisabled}`}>
                                <ProfileSideBar
                                    tabs={tabs}
                                    activeTab={activeTab}
                                    employerPortal
                                    setActiveTab={setActiveTab}
                                    removeSubscriptionInformation
                                    title={t('forms.manage_job.employer_Portal')}
                                    description={t('forms.manage_job.manage_your_jobs_and_candidates')}
                                />
                            </span>
                            {activeTab == 0 &&
                                <PostJob
                                    activeTab={activeTab}
                                    activeSteps={activeSteps}
                                    id={id}
                                    setActiveSteps={setActiveSteps}
                                    setPostJobEnable={setPostJobEnable} />
                            }
                        </div>
                    </>
                ) : (
                    <>
                        <Helmet>
                            <title>FindCV - Create Job</title>
                        </Helmet>
                        <div className={`${styles.container} ${styles.fcvRow} ${postJobEnable ? styles.borderDisabled : styles.borderEnabled}`}>
                            <span className={`${styles.spanStyle} ${postJobEnable ? styles.borderTopBottomEnabled : styles.borderTopBottomDisabled}`}>
                                <ProfileSideBar
                                    tabs={tabs}
                                    activeTab={activeTab}
                                    setActiveTab={setActiveTab}
                                    removeSubscriptionInformation
                                    employerPortal
                                    title={t('forms.manage_job.employer_Portal')}
                                    description={t('forms.manage_job.manage_your_jobs_and_candidates')}
                                />
                            </span>
                            {activeTab == 0 &&
                                <>
                                    {postJobEnable && <PostJob
                                        activeTab={activeTab}
                                        activeSteps={activeSteps}
                                        setActiveSteps={setActiveSteps}
                                        setPostJobEnable={setPostJobEnable} />}
                                    {!postJobEnable && <EmployerPortalJobList setPostJobEnable={setPostJobEnable} />}
                                </>
                            }
                            {activeTab == 1 && <EmployerPortalCandidates setPostJobEnable={setPostJobEnable} />}
                            {activeTab == 2 && <EmployerPortalApplication setPostJobEnable={setPostJobEnable} />}
                        </div>
                    </>
                )}
        </>
    );
}

export default ManageJob;